import { render } from "./OrgInstructors.vue?vue&type=template&id=0d0b385b&scoped=true"
import script from "./OrgInstructors.vue?vue&type=script&lang=js"
export * from "./OrgInstructors.vue?vue&type=script&lang=js"

import "./OrgInstructors.vue?vue&type=style&index=0&id=0d0b385b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0b385b"]])

export default __exports__